var render = function render(){var _vm=this,_c=_vm._self._c;return _c('search-box',{attrs:{"options":_vm.options,"value":_vm.value,"defaultSearchKey":_vm.defaultSearchKey},on:{"input":_vm.search,"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.handleCloseSidebar.apply(null, arguments)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }